/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsSystemBulkMailRoute } from '@jira/router-routes__admin-pages-outgoing-mail-routes/src/globalSettingsSystemBulkMailRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import BulkEmail, { LazyBulkEmail } from './ui/spa/admin-pages/outgoing-mail/bulk-mail/index.tsx';

export const globalSettingsSystemBulkMailRouteEntry: Route = createEntry(
	globalSettingsSystemBulkMailRoute,
	() => ({
		group: 'global-settings',
		// eslint-disable-next-line no-restricted-syntax
		component: BulkEmail,

		navigation: {
			menuId: MenuIdSettings,
		},

		layout: globalSettingsLayout,
		resources: [...getNavigationResources(), navigationSidebarGlobalResource],
		forPaint: [LazyAtlassianNavigation, LazyBulkEmail],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
